module.exports = __webpack_public_path__ + "media/packs/images/flags/HU-2395a8e28246d69def256eea7a0d0f18.png";